import { push } from "connected-react-router";
import getParent from "../../../../helpers/getParent";

export default (event, URI) => async (dispatch) => {
  const isButtonShareHot = getParent("hot-description", event.target, "class");
  const isButtonShareCurated = getParent("published-share-btn", event.target, "class");
  const isButtonShareMobile = getParent("collection-list-share-btn", event.target, "class");

  if (!isButtonShareHot && !isButtonShareCurated && !isButtonShareMobile) {
    dispatch(push(URI));
  }
}